
import Vue from 'vue';
import EuButton from '../Button/Button.vue';
import EuCard from '../Card/Card.vue';
import GeneralTopContent from '../GeneralCard/GeneralTopContent.vue';
import GeneralBodyContent from '../GeneralCard/GeneralBodyContent.vue';
import GeneralBottomContent from '../GeneralCard/GeneralBottomContent.vue';
/**
- Generalcard can be a singular item or multiple with selectable function
- To turn GeneralCard into selection card, simply pass <b>selected</b> prop.
- Accepts Custom desc/list inside Body Content: with <b> < template v-slot:list="props" > </b> then to activate expand function, pass <b> v-if="props.expand" </b> inside tag that's supposed to show when expanded.
**/
export default Vue.extend<any, any, any, any>({
  name: 'GeneralCard',
  data() {
    return {
      expand: false
    };
  },
  components: {
    EuButton,
    EuCard,
    GeneralTopContent,
    GeneralBodyContent,
    GeneralBottomContent
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set id for primary button
     */
    primaryId: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set id for secondary button
     */
    secondaryId: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: 'thin'
    },
    /**
     * Information shown on card
     */
    cardInformation: {
      type: Object,
      required: true
    },
    /**
     * Selecting a card in multiselection
     */
    selected: {
      type: Boolean,
      default: undefined
    },
    /**
     * Set maximum list shown before clicking view more
     */
    maxList: {
      type: Number,
      default: 1
    },
    /**
     * Props for user to customize card header
     */
    customHeader: {
      type: Boolean,
      default: false
    },
    /**
     * Props for user to customize card footer
     */
    customBody: {
      type: Boolean,
      default: false
    },
    /**
     * Props for user to customize card footer
     */
    customFooter: {
      type: Boolean,
      default: false
    },
    /**
     * Set card to disabled
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Set bullet icon on list
     */
    bulletIcon: {
      type: [String, Object]
    },
    /**
     * Make view label forced visible
     */
    forceViewLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Addition info before bottom content
     */
    additionInfo: {
      type: Object
    }
  },
  methods: {
    handleClickCard(e: any) {
      /**
       * Method to click card
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    },
    handleViewMore(e: any) {
      /**
       * Method to click view more on body section
       * @event clickview
       * @type {function}
       */
      this.$emit('clickview', e);
    },
    handleSecondaryButton(e: any) {
      /**
       * Method to click secondary button
       * @event clicksecondary
       * @type {function}
       */
      this.$emit('clicksecondary', e);
    },
    handlePrimaryButton(e: any) {
      /**
       * Method to click primary button
       * @event clickprimary
       * @type {function}
       */
      this.$emit('clickprimary', e);
    },
    handleEditValue(e: any) {
      /**
       * Method to click edit value on addition section
       * @event edit-value
       * @type {function}
       */
      this.$emit('edit-value', e);
    }
  }
});
